// src/components/OpeningAnimation.jsx
import React, { useEffect, useRef } from "react";
import CrescentMoonAnimation from "./CrescentMoonAnimation";
import "./OpeningAnimation.css";

export default function OpeningAnimation({ onFinish }) {
  const rootRef = useRef(null);

  useEffect(() => {
    // show animation for SHOW_MS then fade and call onFinish
    const SHOW_MS = 2000; // visible time
    const timer = setTimeout(() => {
      const el = rootRef.current;
      if (el) {
        el.classList.add("opening-fadeout");
        // wait for fade transition end (match CSS .opening-fadeout transition)
        setTimeout(() => onFinish && onFinish(), 650);
      } else {
        onFinish && onFinish();
      }
    }, SHOW_MS);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="opening-root" ref={rootRef}>
      {/* background image + overlay are in CSS */}
    
      <div className="opening-inner shadow">
        <CrescentMoonAnimation />
        <h1 className="opening-title">HilalUp</h1>
        <p className="opening-sub">Taste Bhi Halal • Niyat Bhi Nek 
          <br></br> Proudly Made in India</p>
      </div>
    </div>
  );
}
